// utilities/errorHandler/classify.ts - utilities/errorHandler.ts split (sub-module classify)


import type {ErrorType} from './types.js';
import { isNetworkError } from './checks.js';
import { isOfflineError } from './checks.js';
import { isTimeoutError } from './checks.js';


/**
 * Determines the appropriate error type from an error object
 */
export function getErrorType(error: unknown, url?: string): ErrorType {
  if (error instanceof Error) {
    // Network-related errors
    if (isNetworkError(error) || isOfflineError(error)) {
      return "network";
    }
    
    // Timeout errors
    if (isTimeoutError(error)) {
      return "timeout";
    }
    
    // Realtime subscription errors
    if (url?.includes("realtime") || url?.includes("subscription")) {
      if (error.message.includes("subscription") || error.message.includes("websocket")) {
        return "realtime";
      }
    }
    
    // Permission errors
    if (error.message.includes("permission") || error.message.includes("access denied")) {
      return "permission";
    }
    
    // Cache errors
    if (error.message.includes("cache") || error.message.includes("cached")) {
      return "cache";
    }
  }
  
  // Check for status codes
  const errObj = error as any;
  if ("status" in errObj && typeof errObj.status === "number") {
    const status = errObj.status;
    if (status >= 400 && status < 500) {
      if (status === 401 || status === 403) return "permission";
      if (status === 408 || status === 429) return "timeout";
      if (status === 400) return "validation";
      return "api";
    }
    if (status >= 500) return "api";
  }
  
  return "general";
}
